import { Injectable } from '@angular/core';
import { HttpClient,HttpRequest,HttpResponse,HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class BotService {
  private API=environment.apiURL+'/bots'
  constructor(private http:HttpClient) { }

  verifyBot(request){
    return this.http.post<any>(this.API+'/verify',request, {observe:'response'})
  }

createBot(request){
  return this.http.post<any>(this.API,request,{observe:'response'})
}

updateBotConfiguration(botId,request) :Observable<any>{
  return this.http.patch<any>(this.API+'/'+botId+'/configuration',request)
}

updateProfilePhoto(botId,file){
  const formData = new FormData();
  formData.append('type', file.type);
  formData.append('file', file);
  return this.http.put<any>(this.API+'/'+botId+'/configuration/photo',formData)
}

updateWebhookUrl(botId,request){
  return this.http.put<any>(this.API+'/'+botId+'/webhook-url',request,{observe:'response'})
}

getBotConfigurationById(botId){
  return this.http.get<any>(this.API+'/'+botId+'/configuration',{observe:'response'})
}

getBotDetailsByMerchantId(merchantId){
  return this.http.get<any>(environment.apiURL+'/merchants/'+merchantId+'/bots',{observe:'response'})
}

getBotDetailsByAdmin(merchantId){
  return this.http.get<any>(environment.apiURL+'/admin/bots?merchant_id='+merchantId,{observe:'response'})
}

updateWelcomeBanner(botId,file){
  const formData = new FormData();
  formData.append('type', file.type);
  formData.append('file', file);
  return this.http.put<any>(this.API+'/'+botId+'/configuration/welcome-banner',formData)
}

public requestMultipleBotConfigurationById(idArray): Observable<any[]> {
  let urls=[]
  idArray.forEach(element => {
    urls.push(this.http.get<any>(this.API+'/'+element.bot_id+'/configuration',{observe:'response'}))
  });
  // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
  return forkJoin(urls);
}

getWebHookUrl(botId){
  return this.http.get<any>(this.API+'/'+botId+'/webhook-url',{observe:'response'})
}
public requestMultipleWebHookUrlById(idArray): Observable<any[]> {
  let urls=[]
  idArray.forEach(element => {
    urls.push(this.http.get<any>(this.API+'/'+element.bot_id+'/webhook-url',{observe:'response'}))
  });
  // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
  return forkJoin(urls);
}


public requestBotShareableLinkById(idArray): Observable<any[]> {
  let urls=[]
  idArray.forEach(element => {
    urls.push(this.http.get<any>(this.API+'/'+element.bot_id+'/shareable-link',{observe:'response'}))
  });
  // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
  return forkJoin(urls);
}

getBotShareableLink(botId){
  return this.http.get<any>(this.API+'/'+botId+'/shareable-link',{observe:'response'})
}

getAllCountrylist() {
  return this.http.get("https://countriesnow.space/api/v0.1/countries/states");
}
getStateByCountry(country) {
  if(country) return this.http.post("https://countriesnow.space/api/v0.1/countries/states", JSON.parse(`{"country": ${country}}`));
  else return null;
}

getCityByState(country) {
  if(country) return this.http.post("https://countriesnow.space/api/v0.1/countries/cities", JSON.parse(`{"country": ${country}}`));
  else return null;
}

getCityByCountryState(country, state) {
  const param = {"country": country, "state": state};
  if(country && state) return this.http.post("https://countriesnow.space/api/v0.1/countries/state/cities", JSON.parse(JSON.stringify(param)));
  else return null;
}

updateCountry(botId, country) {
  return this.http.put<any>(this.API+'/'+botId+'/availability/regions', country);
}
getCountry(botId) {
  return this.http.get<any>(this.API+'/'+botId+'/availability/regions');
}

getLabelsWithBotId(botId) {
  return this.http.get<any>(this.API+ '/' + botId + '/labels');
}
 
updateLabelsWithBotId(botId, labels) {
  return this.http.put<any>(this.API+ '/'+ botId + '/labels', labels);
}

uploadFaqs(botId, faq) {
  const formData = new FormData();
  formData.append('type', faq.type);
  formData.append('file', faq);
  return this.http.put<any>(this.API + '/' + botId + '/faqs', formData);
}

}
